import { ShipmentFeeType } from '@/types';

/**
 * BOXY-414 — a bulk-import sheet put the PRODUCT PRICE in `fee_customer_payable`
 * and the customer was asked for 362,987 IQD of "shipping". The backend now
 * refuses such rows with `CUSTOM_FEE_TOO_HIGH`; these helpers let the preview
 * point at the cell before the merchant confirms.
 */
export const CUSTOM_FEE_TOO_HIGH = 'CUSTOM_FEE_TOO_HIGH';

/** The backend's sentence for a refused custom fee, when the row carries one. */
export const getCustomFeeError = (errors?: Record<string, unknown> | null): string | undefined => {
  if (!errors || typeof errors !== 'object') return undefined;
  // Upload/row-edit validation sends ["message"]; the move-to-orders backstop sends "message".
  const raw = errors.fee_customer_payable;
  const fieldError = Array.isArray(raw) ? raw.find((v) => typeof v === 'string' && v) : raw;
  if (typeof fieldError === 'string' && fieldError) return fieldError;
  return errors.code === CUSTOM_FEE_TOO_HIGH ? CUSTOM_FEE_TOO_HIGH : undefined;
};

/** Refused by the backend, or at least as large as the goods it ships. */
export const isCustomFeeSuspect = (
  fee: number,
  productsValue: number,
  errors?: Record<string, unknown> | null,
): boolean => !!getCustomFeeError(errors) || (fee > 0 && productsValue > 0 && fee >= productsValue);

/** Only a BY_CUSTOMER row charges its custom fee — unless the backend flagged it anyway. */
export const shouldShowCustomFee = (
  fee: number,
  shipmentFeeType: string,
  errors?: Record<string, unknown> | null,
): boolean =>
  fee > 0 && (shipmentFeeType === ShipmentFeeType.BY_CUSTOMER || !!getCustomFeeError(errors));

/** Form value -> PATCH value: an empty field clears the override (null), never 0. */
export const toFeeCustomerPayable = (
  shipmentFeeType: string | undefined,
  rawFee: unknown,
): number | null => {
  if (shipmentFeeType !== ShipmentFeeType.BY_CUSTOMER) return null;
  if (rawFee === undefined || rawFee === null || String(rawFee).trim() === '') return null;
  const fee = Number(rawFee);
  return Number.isFinite(fee) ? fee : null;
};
